// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnswerRequest,
  AnswerResponse,
  ConversationMessageResponse,
  ConversationResponse,
  ConversationUpdateRequest,
  CurrentUserResponse,
  DailyFeedbackResponse,
  FeedbackRequest,
  GrantAdminRequest,
  HTTPValidationError,
  SystemPromptResponse,
  SystemPromptUpdateRequest,
  UsageAnalyticsResponse,
  UserRoleResponse,
} from '../models/index';
import {
    AnswerRequestFromJSON,
    AnswerRequestToJSON,
    AnswerResponseFromJSON,
    AnswerResponseToJSON,
    ConversationMessageResponseFromJSON,
    ConversationMessageResponseToJSON,
    ConversationResponseFromJSON,
    ConversationResponseToJSON,
    ConversationUpdateRequestFromJSON,
    ConversationUpdateRequestToJSON,
    CurrentUserResponseFromJSON,
    CurrentUserResponseToJSON,
    DailyFeedbackResponseFromJSON,
    DailyFeedbackResponseToJSON,
    FeedbackRequestFromJSON,
    FeedbackRequestToJSON,
    GrantAdminRequestFromJSON,
    GrantAdminRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    SystemPromptResponseFromJSON,
    SystemPromptResponseToJSON,
    SystemPromptUpdateRequestFromJSON,
    SystemPromptUpdateRequestToJSON,
    UsageAnalyticsResponseFromJSON,
    UsageAnalyticsResponseToJSON,
    UserRoleResponseFromJSON,
    UserRoleResponseToJSON,
} from '../models/index';

export interface AnswerOperationRequest {
    answerRequest: AnswerRequest;
}

export interface AnswerStreamRequest {
    answerRequest: AnswerRequest;
}

export interface ConversationMessagesRequest {
    conversationId: string;
}

export interface DeleteConversationRequest {
    conversationId: string;
}

export interface FeedbackOperationRequest {
    feedbackRequest: FeedbackRequest;
}

export interface FeedbackDailyRequest {
    from?: Date | null;
    to?: Date | null;
}

export interface GrantAdminOperationRequest {
    grantAdminRequest: GrantAdminRequest;
}

export interface RenameConversationRequest {
    conversationId: string;
    conversationUpdateRequest: ConversationUpdateRequest;
}

export interface RevokeAdminRequest {
    oid: string;
}

export interface UpdateSystemPromptRequest {
    systemPromptUpdateRequest: SystemPromptUpdateRequest;
}

export interface UsageAnalyticsRequest {
    from?: Date | null;
    to?: Date | null;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for answer without sending the request
     */
    async answerRequestOpts(requestParameters: AnswerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['answerRequest'] == null) {
            throw new runtime.RequiredError(
                'answerRequest',
                'Required parameter "answerRequest" was null or undefined when calling answer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/answer`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerRequestToJSON(requestParameters['answerRequest']),
        };
    }

    /**
     * Answer
     */
    async answerRaw(requestParameters: AnswerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnswerResponse>> {
        const requestOptions = await this.answerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnswerResponseFromJSON(jsonValue));
    }

    /**
     * Answer
     */
    async answer(requestParameters: AnswerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnswerResponse> {
        const response = await this.answerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for answerStream without sending the request
     */
    async answerStreamRequestOpts(requestParameters: AnswerStreamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['answerRequest'] == null) {
            throw new runtime.RequiredError(
                'answerRequest',
                'Required parameter "answerRequest" was null or undefined when calling answerStream().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/answer/stream`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AnswerRequestToJSON(requestParameters['answerRequest']),
        };
    }

    /**
     * Answer Stream
     */
    async answerStreamRaw(requestParameters: AnswerStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.answerStreamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Answer Stream
     */
    async answerStream(requestParameters: AnswerStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.answerStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for conversationMessages without sending the request
     */
    async conversationMessagesRequestOpts(requestParameters: ConversationMessagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling conversationMessages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/conversations/{conversation_id}/messages`;
        urlPath = urlPath.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters['conversationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Conversation Messages
     */
    async conversationMessagesRaw(requestParameters: ConversationMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConversationMessageResponse>>> {
        const requestOptions = await this.conversationMessagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConversationMessageResponseFromJSON));
    }

    /**
     * Conversation Messages
     */
    async conversationMessages(requestParameters: ConversationMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConversationMessageResponse>> {
        const response = await this.conversationMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for currentUser without sending the request
     */
    async currentUserRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/me`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Current User
     */
    async currentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CurrentUserResponse>> {
        const requestOptions = await this.currentUserRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserResponseFromJSON(jsonValue));
    }

    /**
     * Current User
     */
    async currentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CurrentUserResponse> {
        const response = await this.currentUserRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteConversation without sending the request
     */
    async deleteConversationRequestOpts(requestParameters: DeleteConversationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling deleteConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/conversations/{conversation_id}`;
        urlPath = urlPath.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters['conversationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Conversation
     */
    async deleteConversationRaw(requestParameters: DeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteConversationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Conversation
     */
    async deleteConversation(requestParameters: DeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for feedback without sending the request
     */
    async feedbackRequestOpts(requestParameters: FeedbackOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['feedbackRequest'] == null) {
            throw new runtime.RequiredError(
                'feedbackRequest',
                'Required parameter "feedbackRequest" was null or undefined when calling feedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/feedback`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FeedbackRequestToJSON(requestParameters['feedbackRequest']),
        };
    }

    /**
     * Feedback
     */
    async feedbackRaw(requestParameters: FeedbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.feedbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Feedback
     */
    async feedback(requestParameters: FeedbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.feedbackRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for feedbackDaily without sending the request
     */
    async feedbackDailyRequestOpts(requestParameters: FeedbackDailyRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = (requestParameters['to'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/admin/feedback/daily`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Feedback Daily
     */
    async feedbackDailyRaw(requestParameters: FeedbackDailyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DailyFeedbackResponse>>> {
        const requestOptions = await this.feedbackDailyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DailyFeedbackResponseFromJSON));
    }

    /**
     * Feedback Daily
     */
    async feedbackDaily(requestParameters: FeedbackDailyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DailyFeedbackResponse>> {
        const response = await this.feedbackDailyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSystemPrompt without sending the request
     */
    async getSystemPromptRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/system-prompt`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get System Prompt
     */
    async getSystemPromptRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemPromptResponse>> {
        const requestOptions = await this.getSystemPromptRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemPromptResponseFromJSON(jsonValue));
    }

    /**
     * Get System Prompt
     */
    async getSystemPrompt(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemPromptResponse> {
        const response = await this.getSystemPromptRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for grantAdmin without sending the request
     */
    async grantAdminRequestOpts(requestParameters: GrantAdminOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['grantAdminRequest'] == null) {
            throw new runtime.RequiredError(
                'grantAdminRequest',
                'Required parameter "grantAdminRequest" was null or undefined when calling grantAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/admin/roles`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantAdminRequestToJSON(requestParameters['grantAdminRequest']),
        };
    }

    /**
     * Grant Admin
     */
    async grantAdminRaw(requestParameters: GrantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.grantAdminRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Grant Admin
     */
    async grantAdmin(requestParameters: GrantAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.grantAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for health without sending the request
     */
    async healthRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/health`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Health
     */
    async healthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string; }>> {
        const requestOptions = await this.healthRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Health
     */
    async health(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string; }> {
        const response = await this.healthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listConversations without sending the request
     */
    async listConversationsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/conversations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Conversations
     */
    async listConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConversationResponse>>> {
        const requestOptions = await this.listConversationsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConversationResponseFromJSON));
    }

    /**
     * List Conversations
     */
    async listConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConversationResponse>> {
        const response = await this.listConversationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listRoles without sending the request
     */
    async listRolesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/admin/roles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Roles
     */
    async listRolesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserRoleResponse>>> {
        const requestOptions = await this.listRolesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserRoleResponseFromJSON));
    }

    /**
     * List Roles
     */
    async listRoles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserRoleResponse>> {
        const response = await this.listRolesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for renameConversation without sending the request
     */
    async renameConversationRequestOpts(requestParameters: RenameConversationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling renameConversation().'
            );
        }

        if (requestParameters['conversationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'conversationUpdateRequest',
                'Required parameter "conversationUpdateRequest" was null or undefined when calling renameConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/conversations/{conversation_id}`;
        urlPath = urlPath.replace(`{${"conversation_id"}}`, encodeURIComponent(String(requestParameters['conversationId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ConversationUpdateRequestToJSON(requestParameters['conversationUpdateRequest']),
        };
    }

    /**
     * Rename Conversation
     */
    async renameConversationRaw(requestParameters: RenameConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.renameConversationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Rename Conversation
     */
    async renameConversation(requestParameters: RenameConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renameConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for revokeAdmin without sending the request
     */
    async revokeAdminRequestOpts(requestParameters: RevokeAdminRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['oid'] == null) {
            throw new runtime.RequiredError(
                'oid',
                'Required parameter "oid" was null or undefined when calling revokeAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/admin/roles/{oid}`;
        urlPath = urlPath.replace(`{${"oid"}}`, encodeURIComponent(String(requestParameters['oid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Revoke Admin
     */
    async revokeAdminRaw(requestParameters: RevokeAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.revokeAdminRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke Admin
     */
    async revokeAdmin(requestParameters: RevokeAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeAdminRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateSystemPrompt without sending the request
     */
    async updateSystemPromptRequestOpts(requestParameters: UpdateSystemPromptRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['systemPromptUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'systemPromptUpdateRequest',
                'Required parameter "systemPromptUpdateRequest" was null or undefined when calling updateSystemPrompt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/system-prompt`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SystemPromptUpdateRequestToJSON(requestParameters['systemPromptUpdateRequest']),
        };
    }

    /**
     * Update System Prompt
     */
    async updateSystemPromptRaw(requestParameters: UpdateSystemPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SystemPromptResponse>> {
        const requestOptions = await this.updateSystemPromptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SystemPromptResponseFromJSON(jsonValue));
    }

    /**
     * Update System Prompt
     */
    async updateSystemPrompt(requestParameters: UpdateSystemPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SystemPromptResponse> {
        const response = await this.updateSystemPromptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for usageAnalytics without sending the request
     */
    async usageAnalyticsRequestOpts(requestParameters: UsageAnalyticsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['from'] != null) {
            queryParameters['from'] = (requestParameters['from'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['to'] != null) {
            queryParameters['to'] = (requestParameters['to'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/admin/analytics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Usage Analytics
     */
    async usageAnalyticsRaw(requestParameters: UsageAnalyticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UsageAnalyticsResponse>> {
        const requestOptions = await this.usageAnalyticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UsageAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Usage Analytics
     */
    async usageAnalytics(requestParameters: UsageAnalyticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UsageAnalyticsResponse> {
        const response = await this.usageAnalyticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
